export const FETCH_LOCKER_PLAN_REQUEST = 'FETCH_LOCKER_PLAN_REQUEST'
export const FETCH_LOCKER_PLAN_SUCCESS = 'FETCH_LOCKER_PLAN_SUCCESS'
